import { render, staticRenderFns } from "./CompetitionsList.vue?vue&type=template&id=6d8caddd&"
import script from "./CompetitionsList.vue?vue&type=script&lang=ts&"
export * from "./CompetitionsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports